import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { completeCallback } from "../lib/auth.ts";
import { Button, Card } from "../ui/index.ts";

export function Callback() {
	const navigate = useNavigate();
	const [error, setError] = useState<string | null>(null);
	const started = useRef(false);

	/*
	 * Exactly once, whatever React does with this effect.
	 *
	 * An authorization code is single-use, and `main.tsx` renders under
	 * `StrictMode`, which in development mounts, unmounts and remounts — running
	 * this effect twice. Both runs read the verifier before either has finished
	 * (it is cleared only after the token response), so both POST the same code:
	 * the issuer honours the first and answers the second with `invalid_grant`,
	 * and whichever loses the race paints "Login failed" over a sign-in that
	 * actually worked. The ref is checked synchronously, so the second run never
	 * starts.
	 */
	useEffect(() => {
		if (started.current) return;
		started.current = true;
		completeCallback()
			.then(({ returnTo }) => navigate(returnTo, { replace: true }))
			.catch((e) => setError(e instanceof Error ? e.message : String(e)));
	}, [navigate]);

	return (
		<main className="grid min-h-dvh place-items-center p-6">
			{error ? (
				<Card className="w-full max-w-md p-8">
					<h1 className="text-2xl font-bold text-content">Login failed</h1>
					<p className="mt-2 font-mono text-sm text-muted">{error}</p>
					<div className="mt-6">
						<Button onClick={() => navigate("/", { replace: true })}>Back</Button>
					</div>
				</Card>
			) : (
				<p className="text-sm text-muted">Signing in…</p>
			)}
		</main>
	);
}
